<template>
    <div class="table-responsive">
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th v-if="wellnessPlanItems.length > 0"></b-th>
                    <b-th>Item:</b-th>
                    <b-th>List Price:</b-th>
                    <b-th>Quantity:</b-th>
                    <b-th>Provider Rate:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="wellnessPlanItems.length <= 0">
                <b-tr>
                    <td colspan="5">
                        <i>No records available</i>
                    </td>
                </b-tr>
            </b-tbody>
            <draggable
                v-else
                v-model="wellnessPlanItems"
                tag="tbody"
                ghost-class="sort-row-ghost"
                drag-class="sort-row-drag"
                :animation="0"
                handle=".handle"
                @start="isRowDragging = true"
                @end="isRowDragging = false"
                @sort="itemsSorted"
            >
                <tr v-for="item in wellnessPlanItems" :key="item.id">
                    <td class="handle">
                        <i class="cursor-move cus-black-white-swatch" />
                    </td>
                    <td>
                        <span v-if="item.item">
                            <router-link
                                v-if="item.item.isactive"
                                :to="{
                                    name: 'item',
                                    params: { id: item.item.encoded_id }
                                }"
                                target="_blank"
                                >{{ item.item.name }}
                                <span v-if="item.item.status == 0"
                                    >(inactive)</span
                                ></router-link
                            >
                            <span v-else>{{ item.item.name }} (deleted)</span>
                        </span>
                        <span v-else>--</span>
                    </td>
                    <td>
                        <span v-if="item.item">
                            {{ getCostPlusPrice(item) }} /
                            {{ item.item.dose }}
                            {{ measurementUnit(item) }}
                        </span>
                        <span v-else>--</span>
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.provider_credit }}%</td>
                    <td class="text-right small text-nowrap">
                        <span
                            v-if="isAbleEditOrDeleteItem"
                            class="cursor-pointer text-nowrap"
                            @click="editItem(item)"
                        >
                            Edit
                        </span>
                        <span v-if="isAbleEditOrDeleteItem">
                            |
                        </span>
                        <span
                            v-if="isAbleEditOrDeleteItem"
                            @click="deleteItem(item)"
                            class="cursor-pointer"
                        >
                            Delete
                        </span>
                    </td>
                </tr>
            </draggable>
        </b-table-simple>

        <modal-delete-item ref="modalDeleteItem" @reload="onSuccess" />
    </div>
</template>

<script>
/**
 * @name TemplateWellnessPlanItemList
 * @description List of template Wellness Plan Item
 */

import TemplateService from "@/services/templates";

export default {
    mixins: [],
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        Draggable: () => import("vuedraggable"),
        ModalDeleteItem: () =>
            import(
                "@/components/setting-template/wellness-plan/modal-delete-item"
            )
    },
    computed: {
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        templateType() {
            return this.$route.params.type;
        },
        isAbleEditOrDeleteItem() {
            return (
                Number(
                    this.$store.state.settingsTemplate?.details
                        ?.wellness_plan_enrollees
                ) <= 0
            );
        }
    },
    watch: {},
    data() {
        return {
            isLoading: false,
            showPagination: false,
            wellnessPlanItems: [],
            isRowDragging: false,
            item: null
        };
    },
    mounted() {
        this.getItems();
    },
    destroyed() {},
    methods: {
        async getItems() {
            try {
                this.isLoading = true;

                const res = await TemplateService.getWellnessPlanItems(
                    this.templateId
                );

                if (res && res.resources && res.code === 200) {
                    this.wellnessPlanItems = res.resources.template_elements;
                }
            } catch (error) {
                console.log(error);
                this._message(error.message, "danger");
            } finally {
                this.isLoading = false;
            }
        },
        getCostPlusPrice(item) {
            return item?.item?.costPlusPrice?.account_format || "";
        },
        measurementUnit(item) {
            return item?.item?.measurement_unit?.value || "";
        },
        editItem(item) {
            this.$store.dispatch("settingsTemplate/openModalItem", {
                isEdit: true,
                item: item
            });
        },
        deleteItem(item) {
            this.$refs.modalDeleteItem.open(this.templateId, item);
        },
        async itemsSorted() {
            const params = {
                id: this.templateId,
                data: this.wellnessPlanItems.map(invItem => invItem.id)
            };
            await TemplateService.updateWellnessPlanTemplateItemsOrder(params)
                .then(res => {
                    if (res.code != 200) {
                        throw "Error: Cannot reorder wellness plan items";
                    }

                    // reset order index
                    this.wellnessPlanItems = this.wellnessPlanItems.map(
                        (item, index) => ({
                            ...item,
                            index: index
                        })
                    );
                })
                .catch(error => {
                    this._message(error, "danger");
                });
        },
        onSuccess() {
            this.$emit("reload-details");
        }
    }
};
</script>
